export function assertNonNull<T>(value: T, msg: string): asserts value is NonNullable<T> {
    if (value === null || value === undefined) {
        throw new Error(msg);
    }
}
